<vs-card class="overflow-hidden">
  <vs-card-header
    [config]="{
      title: 'Ledger Statement',
      subtitle: 'This distributor’s allocation and disbursement position across every contract they’ve sold, for reconciling remittances.'
    }"
    class="[&_h2]:!text-base [&_h2]:!text-gray-900"
  ></vs-card-header>

  <div
    *ngIf="error"
    class="flex items-start gap-2 mx-4 mb-4 rounded-xl bg-red-50 border border-red-200 p-3 text-sm text-red-800"
  >
    <vs-icon name="alert-triangle" size="16" class="mt-0.5 shrink-0"></vs-icon>
    <p>Couldn't load this distributor's ledger statement. Please try again.</p>
  </div>

  <ng-container *ngIf="!error && (statement$ | async) as statement">
    <div *ngIf="hasOutstandingClawback(statement)" class="mx-4 mb-4">
      <div class="flex items-start gap-2 rounded-xl bg-yellow-50 border border-yellow-200 p-3 text-sm text-yellow-800">
        <vs-icon name="info-circle" size="16" class="mt-0.5 shrink-0"></vs-icon>
        <div>
          <p class="font-semibold">This distributor owes a balance back</p>
          <p class="mt-1">
            A negative outstanding payable is money to recover from this distributor — for example a cancellation
            clawback. It is not automatically deducted from their remittances; factor it in when reconciling their next
            payment.
          </p>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Totals and the date range/export controls share one row — the Export button stays usable
       even if the totals failed to load (@error) or are still loading, since export doesn't
       depend on this summary data. -->
  <div *ngIf="filters$ | async as filters" class="flex items-end justify-between gap-4 p-4 flex-wrap">
    <div class="flex flex-wrap gap-4">
      <ng-container *ngIf="!error && (statement$ | async) as statement">
        <div *ngFor="let total of statement.totals" class="border rounded-xl p-4 min-w-[200px]">
          <p class="text-xs font-medium text-gray-600">Outstanding Payable ({{ total.currency }})</p>
          <p class="text-lg font-semibold" [class.text-red-600]="roundToCents(total.outstandingPayable) < 0">
            {{ total.outstandingPayable | currency: total.currency : 'symbol' : '1.2-2' }}
          </p>
          <p class="text-xs text-gray-500 mt-2">
            Net allocation {{ total.netAllocation | currency: total.currency : 'symbol' : '1.2-2' }} · Net disbursement
            {{ total.netDisbursement | currency: total.currency : 'symbol' : '1.2-2' }}
          </p>
        </div>

        <p *ngIf="!statement.totals.length" class="text-sm text-gray-500 italic self-center">
          No ledger activity recorded for this distributor yet.
        </p>
      </ng-container>
    </div>

    <div class="flex items-center gap-4 shrink-0">
      <button
        type="button"
        class="flex items-center gap-2 border border-gray-300 rounded-lg px-3 py-2 bg-white min-w-[220px] hover:border-gray-400 transition-colors"
        [vsMenuTriggerFor]="dateRangeMenu"
      >
        <vs-icon name="calendar" class="text-gray-400" size="16"></vs-icon>
        <span class="flex-1 text-left text-sm text-gray-900">
          {{ filters.startDate | date: 'MMM d' }} - {{ filters.endDate | date: 'MMM d, y' }}
        </span>
        <vs-icon name="chevron-down" class="text-gray-400" size="14"></vs-icon>
      </button>

      <button type="button" vs-button size="md" appearance="outline" [disabled]="exporting" (click)="onExport()">
        <vs-icon [name]="exporting ? 'loading-01' : 'download-01'" [class.animate-spin]="exporting"></vs-icon>
        {{ exporting ? 'Generating...' : 'Export' }}
      </button>
    </div>
  </div>

  <ng-template #dateRangeMenu>
    <vs-menu class="!z-50">
      <div class="p-4">
        <vs-date-picker
          [range]="true"
          [rangeValue]="filters$ | async"
          (selectionChanged)="onDateRangeChange($event)"
        ></vs-date-picker>
      </div>
    </vs-menu>
  </ng-template>

  <div class="px-4 pb-4">
    <vs-connected-table
      [endpoint]="contractsEndpoint$ | async"
      [columns]="columns$ | async"
      [queryParams]="contractsQueryParams$ | async"
    ></vs-connected-table>
  </div>

  <ws-record-seller-payout-dialog (closed)="$event && refresh()"></ws-record-seller-payout-dialog>
</vs-card>
